import { render, staticRenderFns } from "./EyeRefresh.vue?vue&type=template&id=072d7d96&scoped=true"
import script from "./EyeRefresh.vue?vue&type=script&lang=js"
export * from "./EyeRefresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072d7d96",
  null
  
)

export default component.exports